(function () {
	'use strict';

	function initAddingSavedCourses() {
		const addingSavedCourses = document.querySelectorAll('.cmp-flindersonline-adding-saved-courses button');
		
		// Get saved courses from localStorage
		const savedCourses = JSON.parse(localStorage.getItem('flinders_saved_courses') || '[]');
		
		addingSavedCourses.forEach(button => {
			// Check if this course is in localStorage and set initial state
			const coursePath = button.getAttribute('data-course-path');
			if (coursePath && savedCourses.includes(coursePath)) {
				button.classList.add('active');
				
				// Set initial icon state
				const isHeartIcon = button.getAttribute('data-icon') === 'heartShape';
				if (isHeartIcon) {
					const heartIcon = button.querySelector('.course-heart-icon');
					const heartSolidIcon = button.querySelector('.course-heart-solid-icon');
					
					if (heartIcon) heartIcon.style.opacity = '0';
					if (heartSolidIcon) heartSolidIcon.style.opacity = '1';
				} else {
					const plusIcon = button.querySelector('.course-plus-icon');
					const minusIcon = button.querySelector('.course-minus-icon');
					
					if (plusIcon) plusIcon.style.opacity = '0';
					if (minusIcon) minusIcon.style.opacity = '1';
				}
			}

			button.addEventListener('click', function () {
				this.classList.toggle('active');
				
				// Get the current icon state
				const isHeartIcon = this.getAttribute('data-icon') === 'heartShape';
				const isActive = this.classList.contains('active');
				
				// Get the course path from the button's data attribute
				const coursePath = this.getAttribute('data-course-path');
				
				// Handle localStorage operations
				if (coursePath) {
					let savedCourses = JSON.parse(localStorage.getItem('flinders_saved_courses') || '[]');
					
					if (isActive) {
						// Add course path if not already in the array
						if (!savedCourses.includes(coursePath)) {
							savedCourses.push(coursePath);
							localStorage.setItem('flinders_saved_courses', JSON.stringify(savedCourses));
						}
					} else {
						// Remove course path from array
						savedCourses = savedCourses.filter(path => path !== coursePath);
						
						// If array is empty, remove the localStorage item
						if (savedCourses.length === 0) {
							localStorage.removeItem('flinders_saved_courses');
						} else {
							localStorage.setItem('flinders_saved_courses', JSON.stringify(savedCourses));
						}
					}
				}
				
				// Update the icon based on the state
				if (isHeartIcon) {
					const heartIcon = this.querySelector('.course-heart-icon');
					const heartSolidIcon = this.querySelector('.course-heart-solid-icon');
					
					if (heartIcon) {
						heartIcon.style.opacity = isActive ? '0' : '1';
					}
					if (heartSolidIcon) {
						heartSolidIcon.style.opacity = isActive ? '1' : '0';
					}
				} else {
					const plusIcon = this.querySelector('.course-plus-icon');
					const minusIcon = this.querySelector('.course-minus-icon');
					
					if (plusIcon) {
						plusIcon.style.opacity = isActive ? '0' : '1';
					}
					if (minusIcon) {
						minusIcon.style.opacity = isActive ? '1' : '0';
					}
				}
			});
		});
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAddingSavedCourses);
	} else {
		initAddingSavedCourses();
	}
})();